module.exports = __webpack_public_path__ + "img/9 ir.77dcda49.jpg";